/*
  CLEAR PDF Export (from scratch)
  Requirement: PDF/download should include ONLY the questions + the user's answers.
  No scoring.
  Uses a standalone print window with minimal structure.
*/

function buildClearPromptIndex(){
  const doc = window.CLEAR_DOC;
  const index = {};
  if(!doc) return index;

  doc.parts.forEach((part, pIdx) => {
    part.sections.forEach((sec, sIdx) => {
      if (sec.reflection && sec.reflection.length) {
        sec.reflection.forEach((qText, qIdx) => {
          const id = `p${pIdx+1}_s${sIdx+1}_r${qIdx+1}`;
          index[id] = { section: sec.title, kind: 'Reflection Questions', number: qIdx+1, prompt: qText };
        });
      }
      if (sec.spiritual && sec.spiritual.length) {
        sec.spiritual.forEach((qText, qIdx) => {
          const id = `p${pIdx+1}_s${sIdx+1}_si${qIdx+1}`;
          index[id] = { section: sec.title, kind: 'Spiritual Integration', number: qIdx+1, prompt: qText };
        });
      }
    });
  });

  return index;
}

function clearCollectAnswers(){
  const form = document.getElementById('clearForm');
  const out = {};
  if(!form) return out;
  form.querySelectorAll('textarea').forEach(t => {
    out[t.name] = t.value || '';
  });
  return out;
}

function openClearPdfWindow(){
  const name = document.getElementById('name')?.value || '';
  const email = document.getElementById('email')?.value || '';
  const date = document.getElementById('date')?.value || '';

  const answers = clearCollectAnswers();
  const idx = buildClearPromptIndex();

  // Build a complete list of prompts (ALL questions), then attach answers (may be blank)
  // Group by section -> kind
  const groups = {};

  const doc = window.CLEAR_DOC;
  if (doc) {
    doc.parts.forEach((part, pIdx) => {
      part.sections.forEach((sec, sIdx) => {
        // Reflection Questions
        if (sec.reflection && sec.reflection.length) {
          sec.reflection.forEach((qText, qIdx) => {
            const id = `p${pIdx+1}_s${sIdx+1}_r${qIdx+1}`;
            const secTitle = sec.title;
            const kind = 'Reflection Questions';
            groups[secTitle] = groups[secTitle] || {};
            groups[secTitle][kind] = groups[secTitle][kind] || [];
            groups[secTitle][kind].push({
              number: qIdx + 1,
              prompt: qText,
              answer: answers[id] || ''
            });
          });
        }

        // Spiritual Integration
        if (sec.spiritual && sec.spiritual.length) {
          sec.spiritual.forEach((qText, qIdx) => {
            const id = `p${pIdx+1}_s${sIdx+1}_si${qIdx+1}`;
            const secTitle = sec.title;
            const kind = 'Spiritual Integration';
            groups[secTitle] = groups[secTitle] || {};
            groups[secTitle][kind] = groups[secTitle][kind] || [];
            groups[secTitle][kind].push({
              number: qIdx + 1,
              prompt: qText,
              answer: answers[id] || ''
            });
          });
        }
      });
    });
  }

  // sort entries
  Object.values(groups).forEach(kinds => {
    Object.values(kinds).forEach(list => list.sort((a,b)=>a.number-b.number));
  });

  const win = window.open('', 'ClearPdf', 'width=960,height=900,scrollbars=yes');
  if(!win){
    alert('Popup blocked. Please allow popups to download the PDF.');
    return;
  }

  const cssHref = '../css/fortify.css';

  const sectionsHtml = Object.entries(groups).map(([secTitle, kinds]) => {
    const blocks = Object.entries(kinds).map(([kind, list]) => {
      const items = list.map(q => {
        const answerHtml = fortifyEscapeHtml(q.answer).replaceAll('\n','<br>');
        return `
          <div class="q" style="page-break-inside:avoid;">
            <div class="small" style="letter-spacing:.12em;text-transform:uppercase;">${fortifyEscapeHtml(kind)} · ${q.number}</div>
            <div style="margin-top:6px;"><b>${fortifyEscapeHtml(q.prompt)}</b></div>
            <div style="margin-top:10px; color: var(--muted); line-height:1.65;">${answerHtml || '<em>(no response)</em>'}</div>
          </div>
        `;
      }).join('');

      return `
        <div class="hr"></div>
        <div class="badge">${fortifyEscapeHtml(kind)}</div>
        ${items}
      `;
    }).join('');

    return `
      <div class="realm" style="margin-top:18px;">
        <div class="realm__band">
          <h3 class="realm__title">${fortifyEscapeHtml(secTitle)}</h3>
        </div>
        <div class="realm__inner">
          ${blocks}
        </div>
      </div>
    `;
  }).join('');

  win.document.write(`<!doctype html>
<html lang="en">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>CLEAR — Questions & Answers</title>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap" rel="stylesheet">
  <link rel="stylesheet" href="${cssHref}">
  <style>
    /* PDF should be Q&A only: remove extra sections */
    @media print { .actions { display:none !important; } }
    .cover{padding:26px 22px;border-bottom:1px solid var(--line)}
    .cover .k{letter-spacing:.35em;text-transform:uppercase;font-size:12px;color:var(--muted)}
    .cover .t{margin:10px 0 6px;font-size:30px;line-height:1.12}
    .cover .s{margin:0;color:var(--muted)}
  </style>
</head>
<body class="bg">
  <main class="doc">
    <section class="doc__panel">
      <div class="cover">
        <div class="k">THE SOVEREIGNTY PATH</div>
        <h1 class="t">CLEAR — Questions & Answers</h1>
        <p class="s">Identification Before Change · No scoring · Client export</p>
        <div class="actions" style="margin-top:14px; display:flex; gap:10px; flex-wrap:wrap;">
          <button class="btn" onclick="window.print()">Download / Print PDF</button>
          <button class="btn secondary" onclick="window.close()">Close</button>
        </div>
      </div>

      <div class="doc__body">
        <table class="table" aria-label="Client info">
          <tbody>
            <tr><td style="width:30%"><b>Name</b></td><td>${fortifyEscapeHtml(name)}</td></tr>
            <tr><td><b>Email</b></td><td>${fortifyEscapeHtml(email)}</td></tr>
            <tr><td><b>Date</b></td><td>${fortifyEscapeHtml(date)}</td></tr>
          </tbody>
        </table>

        ${sectionsHtml || '<div class="notice" style="margin-top:14px;">No responses captured.</div>'}

        <div class="hr"></div>
        <div class="small" style="letter-spacing:.12em;text-transform:uppercase;">DeanHobson.com | The Sovereignty Path</div>
      </div>
    </section>
  </main>
</body>
</html>`);

  win.document.close();
}